import ruLocale from 'element-ui/lib/locale/lang/ru-RU'
import home from './ru/home'

const ru = {
    language: 'Русский',
    message: {
        'home': {
            ...home,
            enterEmail: 'Введите электронную почту',
            save: 'Сохранить',
            saveSuccess: 'Успешно сохранено',
            pointHistory: 'История баллов',
            type: 'Тип',
            remark: 'Примечание',
            pendingComment: 'Ожидает отзыва',
            commented: 'Оценено',
            selectDate: 'Выберите дату',
            loginSuccess: 'Вход выполнен успешно',
            loginFail: 'Ошибка входа',
            close: 'Закрыть',
            required: 'Обязательно',
            nickname: 'Псевдоним',
            enterNickname: 'Введите псевдоним',
            gender: 'Пол',
            male: 'Мужской',
            female: 'Женский',
            secret: 'Не указывать',
            birthday: 'День рождения',
            checkoutLoadFailed: 'Не удалось загрузить информацию для оформления заказа. Повторите попытку позже.',
            checkoutErrorTitle: 'Уведомление',
            goAddAddress: 'Добавить адрес доставки',
            shop_order_selectOrAddAddress: 'Сначала добавьте адрес доставки и установите его по умолчанию перед оформлением заказа.',
            shop_order_cartEmpty: 'Корзина пуста, оформление невозможно.',
            shop_order_cartHasNotActive: 'Есть неопубликованные или недействительные товары, оформление невозможно.',
            shop_order_cartHasNotMarketable: 'Есть снятые с продажи товары, оформление невозможно.',
            shop_order_cartHasLowStock: 'Недостаточно товара на складе, оформление невозможно.',
            shop_order_cartHasExpiredGoods: 'Некоторые товары магазина просрочены, оформление невозможно.',
            shop_order_typeIsNull: 'Не удалось определить тип заказа, проверьте тип товара.',
            shop_order_goodsNotFound: 'Информация о товаре отсутствует или удалена.',
            shop_order_giftNotForSale: 'Подарочные товары нельзя купить напрямую.',
            common_message_badRequest: 'Неверный запрос, проверьте товар и параметры.',
        },
    },
    '手机号码最小长度为8位': '«Минимальная длина номера мобильного телефона — 8 цифр»',
    '邮箱账号名称最小长度为6位': '«Минимальная длина имени учетной записи электронной почты — 6 символов»',
    '邮箱只能包含英文，数字等字符': "«Почтовый ящик может содержать только такие символы, как английский язык и цифры»",
    '请选择正确的收货地址': '«Пожалуйста, выберите правильный адрес доставки»',
    Dict_language_status_0: 'Отключено',
    Dict_language_status_1: 'Включено',
    Dict_member_label_type_1: 'Условная метка',
    Dict_member_label_type_2: 'Ручная метка',
    Dict_member_level_type_0: 'Уровень потребления (LV)',
    Dict_member_level_type_1: 'Платный участник (VIP)',
    Dict_member_growth_action_type_1: 'Оформление заказа',
    Dict_member_growth_action_type_2: 'Ежедневный вход',
    Dict_member_growth_action_type_3: 'Публикация отзыва',
    Dict_member_growth_action_type_4: 'Заполнение профиля',
    Dict_paid_member_payment_type_0: 'Оплата с баланса',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'Действителен',
    Dict_paid_member_record_status_1: 'Истёк',
    Dict_paid_member_record_status_2: 'Возвращён',
    Dict_point_lottery_prize_type_0: 'Баллы',
    Dict_point_lottery_prize_type_1: 'Купон',
    Dict_point_lottery_prize_type_2: 'Физический приз',
    Dict_point_lottery_prize_type_3: 'Спасибо за участие',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'Электронная почта',
    Dict_notification_channel_type_2: 'Внутреннее сообщение',
    Dict_notification_channel_type_3: 'Push-уведомление',
    Dict_announcement_status_0: 'Черновик',
    Dict_announcement_status_1: 'Опубликовано',
    Dict_announcement_status_2: 'Снято с публикации',
    Dict_live_permission_status_0: 'Не подано',
    Dict_live_permission_status_1: 'На рассмотрении',
    Dict_live_permission_status_2: 'Активировано',
    Dict_live_permission_status_3: 'Отклонено',
    Dict_live_room_status_0: 'Не начато',
    Dict_live_room_status_1: 'В эфире',
    Dict_live_room_status_2: 'Завершено',
    Dict_live_room_status_3: 'Аварийный обрыв',
    Dict_live_room_type_0: 'Трансляция платформы',
    Dict_live_room_type_1: 'Трансляция продавца',
    Dict_store_type_0: 'Индивидуальный магазин',
    Dict_store_type_1: 'Корпоративный магазин',
    Dict_store_sign_status_0: 'Ожидает подписания',
    Dict_store_sign_status_1: 'Подписано',
    Dict_store_sign_status_2: 'Расторгнуто',
    Dict_store_business_change_status_0: 'Ожидает проверки',
    Dict_store_business_change_status_1: 'Одобрено',
    Dict_store_business_change_status_2: 'Отклонено',
    Dict_decoration_page_type_0: 'Главная страница',
    Dict_decoration_page_type_1: 'Страница категории',
    Dict_decoration_page_type_2: 'Страница акции',
    Dict_decoration_page_type_3: 'Пользовательская страница',
    Dict_decoration_status_0: 'Черновик',
    Dict_decoration_status_1: 'Опубликовано',
    Dict_decoration_popup_trigger_page_0: 'Главная платформы',
    Dict_decoration_popup_trigger_page_1: 'Центр участника',
    Dict_decoration_popup_trigger_page_2: 'Оплата успешна',
    Dict_decoration_popup_target_user_0: 'Все пользователи',
    Dict_decoration_popup_target_user_1: 'Бесплатные участники',
    Dict_decoration_popup_target_user_2: 'Платные участники',
    Dict_decoration_popup_frequency_0: 'Один раз навсегда',
    Dict_decoration_popup_frequency_1: 'При каждом входе',
    Dict_decoration_popup_frequency_2: 'Пользовательская частота',
    Dict_track_event_type_page_view: 'Просмотр страницы',
    Dict_track_event_type_click: 'Клик',
    Dict_track_event_type_add_to_cart: 'Добавить в корзину',
    Dict_track_event_type_search: 'Поиск',
    Dict_track_event_type_purchase: 'Покупка',
    Dict_track_event_type_live_watch: 'Смотреть трансляцию',
    Dict_reconcile_period_type_0: 'Ежедневно',
    Dict_reconcile_period_type_1: 'Еженедельно',
    Dict_reconcile_period_type_2: 'Ежемесячно',
    Dict_store_settlement_status_0: 'Ожидает расчёта',
    Dict_store_settlement_status_1: 'Рассчитано',
    Dict_distributor_status_0: 'Ожидает проверки',
    Dict_distributor_status_1: 'Проверено',
    Dict_distributor_status_2: 'Отклонено',
    Dict_distribution_commission_type_0: 'Прямая комиссия',
    Dict_distribution_commission_type_1: 'Косвенная комиссия',
    Dict_configuration_status_0: 'Отключено',
    Dict_configuration_status_1: 'Включено',
    ...ruLocale
}
export default ru
